import React from 'react';
import { MaskText, SectionLabel } from './ui/Reveal';
type PageHeaderProps = {
  eyebrow: string;
  /** Split lines with "|". */
  title: string;
  lead?: string;
  meta?: string;
};

/** Consistent editorial page masthead used across inner pages. */
export function PageHeader({
  eyebrow,
  title,
  lead,
  meta
}: PageHeaderProps) {
  return <header className="bg-surface pb-14 pt-32 sm:pb-20 sm:pt-44" aria-label={`${eyebrow} header`} data-id="element-391" data-mp="3mg297330harn">
      <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-392" data-mp="2yqga0fmn2vjn">
        <SectionLabel data-id="element-393" data-mp="2trmzmw2nfknp">{eyebrow}</SectionLabel>
        <h1 className="mt-6 max-w-5xl font-display text-[12vw] font-extrabold uppercase leading-[0.86] tracking-tightest sm:text-[8vw] lg:text-[6vw]" data-id="element-394" data-mp="2tor053b5knx5">
          <MaskText text={title} data-id="element-395" data-mp="33orjuqcxp61v" />
        </h1>
        {lead || meta ? <div className="mt-10 grid gap-6 border-t border-line pt-8 lg:grid-cols-[1.2fr_auto] lg:items-start" data-id="element-396" data-mp="2fz71a8kp0at4">
            {lead ? <p className="max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-397" data-mp="2azkou1couyld">{lead}</p> : <span data-id="element-398" data-mp="2hygj0esq5iug" />}
            {meta ? <p className="label text-muted" data-id="element-399" data-mp="2m0bl3lihc09a">{meta}</p> : null}
          </div> : null}
      </div>
    </header>;
}